<div class="container">
  <span class="title"> {{ newsBannerSlide.title }}</span>
  @if (newsBannerSlide.subtitle) {
    <strong> {{ newsBannerSlide.subtitle }}</strong>
  }
  <span> {{ newsBannerSlide.description }}</span>
  @if (newsBannerSlide.link) {
    <a
      href="{{ newsBannerSlide.link }}"
      target="_blank"
      class="inwi-text-button-medium-primary align-self-center link-button">
      <div class="button-content">
        <div class="button-text">
          {{ newsBannerSlide.linkText ?? 'Link aufrufen' }}
        </div>
      </div>
    </a>
  }
</div>
